import React, { useContext, useEffect, useState } from "react";
import WarningIcon from '@material-ui/icons/Warning';

import {
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  TextField,
  Box,
  Button,
} from "@material-ui/core";
import InputMask from "react-input-mask";

import Autocomplete from "@material-ui/lab/Autocomplete";

import useStyles from "./styles";
import { AutoRegistrationContext } from "../../context/AutoRegistrationProvider";
import { useFormik } from "formik";
import { validationSchemaCNPJ, validationSchemaCPF, validationSchemaDocumentInternational } from "./validationSchema";
import apiV2 from "../../../../api/api-client-v2";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { toast } from "react-toastify";

export const StepOne = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [typeDocumentCheck, setTypeDocumentCheck] = useState("individual");
  const [documentType, setDocumentType] = useState('');

  const { setStep, data, setData, branches, setBranches } = useContext(
    AutoRegistrationContext
  );

  const handleSubmitForm = (values) => {
    setData(values);
    setStep(2);
  };

  useEffect(() => {
    if (data?.branches) return;
    apiV2
      .get("branches")
      .then((response) => {
        setBranches([...response?.data]);
      })
      .catch(() => {
        toast.error("Erro ao buscar filiais!");
      });

    return () => {
      setEmail("");
    };
  }, []); // eslint-disable-line

  const formik = useFormik({
    initialValues: {
      typeClient: data?.typeClient || "client",
      typeDocument: data?.typeDocument || "",
      cpf: data?.cpf || "",
      cnpj: data?.cnpj || "",
      documentInternational: data?.documentInternational || "",
      company: data?.company || "",
      branches: data?.branches || "",
    },
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: false,
    validationSchema:
      typeDocumentCheck === "individual"
        ? validationSchemaCPF
        : typeDocumentCheck === "legal_entity"
        ? validationSchemaCNPJ
        : validationSchemaDocumentInternational,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const handleGoBack = () => {
    formik.resetForm();
    setData({});
    setStep(0);
  };

  const isDisabledNextBtn = () => {
    const { typeClient, typeDocument, branches, cpf, cnpj, company, documentInternational } =
      formik.values;
    if (!typeClient || !branches) return true;

    if (
      !typeDocument ||
      (typeDocument === "individual" &&
        cpf.replace(/[/._-]/gi, "").length < 11) ||
      (typeDocument === "legal_entity" &&
        (cnpj.replace(/[/._-]/gi, "").length < 14 || !company)) ||
      (typeDocument === "intl" &&
        (documentInternational.replace(/[/._-]/gi, "").length < 5))
    )
      return true;

    const errors = Object.values(formik.errors);
    if (errors.length > 0) return true;

    return false;
  };

  return (
    <div className={classes.registrationContainer}>
      <form className={classes.form} onSubmit={formik.handleSubmit}>
        <Box className={classes.typeClientContainer}>
          <Typography variant="h5" align="left">
            Eu sou?
          </Typography>
          <RadioGroup
            row
            aria-label="typeClient"
            name="typeClient"
            data-cy="typeClient-rdo"
            value={formik.values.typeClient}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={classes.radioButtonIAm}
          >
            <FormControlLabel
              value="client"
              control={<Radio />}
              label="Cliente"
              flex={1}
            />
            <FormControlLabel
              value="transporter"
              control={<Radio />}
              label="Transportadora"
              flex={1}
            />
            <FormControlLabel
              value="vendor"
              control={<Radio />}
              label="Fornecedor"
              flex={1}
            />
          </RadioGroup>
        </Box>
        <Box className={classes.typeClientContainer}>
          <Typography variant="h5" align="left">
            Tipo de usuário*
          </Typography>
          <RadioGroup
            row
            aria-label="typeDocument"
            name="typeDocument"
            id="typeDocument-rdo"
            data-cy="typeDocument-rdo"
            value={formik.values.typeDocument}
            onChange={(e) => {
              formik.setFieldValue("cpf", "");
              formik.setFieldValue("cnpj", "");
              formik.setFieldValue("company", "");
              setTypeDocumentCheck(e.target.value);
              formik.handleChange(e);
            }}
            className={classes.radioButtonIAm}
          >
            <FormControlLabel
              value="individual"
              control={<Radio  onClick={()=> setDocumentType('O CPF deve ser do cliente.')}/>}
              label="Pessoa física"
              flex={1}
            />
            <FormControlLabel
              value="legal_entity"
              control={<Radio onClick={()=> setDocumentType('O CNPJ e razão social devem ser do cliente.')}/>}
              label="Pessoa jurídica"
              flex={1}
            />
            <FormControlLabel
              value="intl"
              control={<Radio onClick={()=> setDocumentType('O documento internacional deve ser do cliente.')}/>}
              label="Internacional"
              flex={1}
            />
          </RadioGroup>
          {(documentType === '')
            ? null
            : (
            <Box className={classes.warning}>
              <WarningIcon fontSize='small' className={classes.warningIcon}/>
              <Typography className={classes.msg}>{documentType}</Typography>
            </Box>
            )
          }
        </Box>
        {formik.values.typeDocument === "individual" && (
          <Box className={classes.documentNumberContainer}>
            <div style={{ width: "100%" }}>
              <Typography variant="h5" align="left">
                CPF*
              </Typography>
              <InputMask
                id="cpf-inp"
                data-cy="cpf-inp"
                name="cpf"
                mask={"999.999.999-99"}
                alwaysShowMask
                value={formik.values.cpf}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              >
                <TextField
                  label={"Informe seu CPF"}
                  style={{ width: "100%" }}
                  variant="outlined"
                  error={!!formik.errors.cpf}
                  helperText={formik.errors.cpf && formik.errors.cpf}
                />
              </InputMask>
            </div>
          </Box>
        )}
        {formik.values.typeDocument === "legal_entity" && (
          <Box className={classes.documentNumberContainer}>
            <div>
              <Typography variant="h5" align="left">
                CNPJ*
              </Typography>
              <InputMask
                id="cnpj-inp"
                data-cy="cnpj-inp"
                name="cnpj"
                mask={"99.999.999/9999-99"}
                alwaysShowMask
                value={formik.values.cnpj}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              >
                <TextField
                  label={"Informe seu CNPJ"}
                  style={{ width: "100%" }}
                  variant="outlined"
                  error={!!formik.errors.cnpj}
                  helperText={formik.errors.cnpj && formik.errors.cnpj}
                />
              </InputMask>
            </div>
            <div>
              <Typography variant="h5" align="left">
                Razão social*
              </Typography>
              <TextField
                id="company-inp"
                data-cy="company-inp"
                name="company"
                label={"Informe sua razão social"}
                style={{ width: "100%" }}
                value={formik.values.company}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={!!formik.errors.company}
                helperText={formik.errors.company && formik.errors.company}
                variant="outlined"
              />
            </div>
          </Box>
        )}
        {formik.values.typeDocument === "intl" && (
          <Box className={classes.documentNumberContainer}>
            <div style={{ width: "100%" }}>
              <Typography variant="h5" align="left">
                Documento*
              </Typography>
                <TextField
                  label={"Informe seu documento"}
                  style={{ width: "100%" }}
                  variant="outlined"
                  error={!!formik.errors.document}
                  helperText={formik.errors.document && formik.errors.document}
                  onChange={formik.handleChange}
                  name="documentInternational"
                  inputProps={{ maxLength: 20 }}
                />
            </div>
          </Box>
        )}
        <Box className={classes.selectBranches}>
          <Typography variant="h5" align="left">
            Local de carga ou descarga*
          </Typography>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="branches-slt"
              name="branches"
              data-cy="branches-slt"
              noOptionsText="Não encontrado"
              getOptionSelected={() => ({id: -1, name: 'Informe o local de carga ou descarga'})}
              value={branches.find((item) => {
                return item.id === formik.values.branches;
              }) || {id: -1, name: 'Informe o local de carga ou descarga'}}
              onChange={(_, value) => {
                formik.setFieldValue("branches", value?.id);
                if (value?.email) {
                  setEmail(value?.email);
                } else {
                  setEmail("");
                }
              }}
              options={branches}
              disableClearable
              getOptionLabel={(option) => option?.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Informe o local de carga ou descarga (ex: Cargill Uberlândia)"
                  variant="outlined"
                />
              )}
            />
            {!!email && (
              <Typography variant="body1" className={classes.contactSupport}>
                Caso ocorra algum problema durante o cadastro, por favor, envie
                um e-mail para <span>{email}</span> descrevendo o ocorrido.
              </Typography>
            )}
          </FormControl>
        </Box>
        <Box className={classes.actionButtons}>
          <Button
            id="goBack-btn"
            data-cy="goBack-btn"
            variant="outlined"
            type="button"
            onClick={handleGoBack}
            className="goBack"
            size="large"
          >
            <ArrowBackIosIcon /> Voltar
          </Button>
          <Box className="goNext">
            *Preenchimento obrigatório.
            <Button
              id="submit-btn"
              data-cy="submit-btn"
              variant="contained"
              className="next"
              disabled={isDisabledNextBtn()}
              type="submit"
              size="large"
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </form>
    </div>
  );
};
